import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from './IfscMasterTable/constants';

export const buildIfscMasterFetchRequest = ({
    pageNumber = DEFAULT_PAGE_NUMBER,
    pageSize = DEFAULT_PAGE_SIZE,
    filter = {},
    sorted = {}

})=>{
     return {pageNumber,pageSize,filter: filter || {},sorted: sorted || {}
  };
}